const t = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M8.95505%208L6.71401%2014.1472H37.759L40%208H8.95505ZM5.59479%2017.2182L3.35375%2023.3642H34.3987L36.6397%2017.2182H5.59479ZM2.24104%2026.4365L0%2032.5811H31.045L33.2834%2026.4352C33.2847%2026.4365%202.24104%2026.4365%202.24104%2026.4365Z'%20fill='%23009FDF'/%3e%3c/svg%3e";
export {
  t as default
};
